module.exports = __webpack_public_path__ + "static/media/INZ1252.7a2e1f13.pdf";